export function trackEvent(eventName: string, params?: object){
    // @ts-ignore
    window.dataLayer.push({
        event: eventName,
        ...params
    })
}